export const PHD_THESES_VIEW_CONFIG = {
  mine: {
    showApprove: false,
    showDeny: false,
    showArchive: true,
    showRestore: true,
    showCopy: false,
    showDownload: true,
  },
  active: {
    showApprove: false,
    showDeny: false,
    showArchive: true,
    showRestore: false,
    showCopy: false,
    showDownload: true,
  },
  pending: {
    showApprove: true,
    showDeny: true,
    showArchive: false,
    showRestore: false,
    showCopy: false,
    showDownload: false,
  },
  archived: {
    showApprove: false,
    showDeny: false,
    showArchive: false,
    showRestore: true,
    showCopy: true,
    showDownload: true,
  },
};

export const resolvePhdThesesViewConfig = (status) =>
  PHD_THESES_VIEW_CONFIG[status] || PHD_THESES_VIEW_CONFIG.active;
